import React from 'react';
import PropTypes from 'prop-types';
import PlaceholderComponent from "./PlaceholderComponent";
import Lazyload from 'react-lazyload';

class PortfolioPhoto extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
                <figure className="image wow fadeInUp fast">
                    <Lazyload height={400} offset={200} once placeholder={<PlaceholderComponent/>}>
                        <img src={this.props.thumbnailUrl}
                             alt={this.props.alt}
                             title={this.props.alt}/>


                    </Lazyload>

                </figure>
        );
    }
}
PortfolioPhoto.propTypes = {
    index: PropTypes.number,
    alt: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    url: PropTypes.string,
    columnSize: PropTypes.string,
    caption: PropTypes.string
};

export default PortfolioPhoto


// WEBPACK FOOTER //
// ./src/components/PortfolioPhoto.js